module.exports = __webpack_public_path__ + "static/benefits-img8-7375a004d20f184fc0217c1c7c4f3fee.png";